import { Link, NavLink, useNavigate } from "react-router-dom";
import { useAuth } from "@/lib/auth";
import { NAV } from "@/constants/testIds";
import { LogOut, User2 } from "lucide-react";

const link = ({ isActive }) =>
  `font-mono text-xs uppercase tracking-[0.2em] px-3 py-2 border border-transparent ${isActive ? "text-[#CCFF00] border-[#CCFF00]/50" : "text-white/70 hover:text-white"}`;

export default function Nav() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  return (
    <header className="sticky top-0 z-50 backdrop-blur-2xl bg-black/60 border-b border-white/10">
      <div className="mx-auto max-w-[1400px] px-6 lg:px-10 h-16 flex items-center justify-between">
        <Link to="/" data-testid={NAV.logo} className="flex items-center gap-2">
          <div className="w-6 h-6 bg-[#FF3366]" />
          <span className="font-display font-black text-lg tracking-tighter">
            DIGITAL<span className="text-[#CCFF00]">/</span>DROPS
          </span>
        </Link>
        <nav className="hidden md:flex items-center gap-1">
          <NavLink to="/" end data-testid={NAV.storeLink} className={link}>Store</NavLink>
          <NavLink to="/leaderboard" data-testid="nav-leaderboard-link" className={link}>Leaderboard</NavLink>
          <NavLink to="/studio" data-testid={NAV.studioLink} className={link}>Creator Studio</NavLink>
          <NavLink to="/library" data-testid={NAV.libraryLink} className={link}>My Library</NavLink>
        </nav>
        <div className="flex items-center gap-3">
          {user ? (
            <>
              <div className="hidden sm:flex items-center gap-2 text-xs font-mono text-white/70">
                <User2 className="w-3.5 h-3.5" />
                <span data-testid={NAV.userName}>{user.name}</span>
              </div>
              <button
                data-testid={NAV.logoutBtn}
                onClick={async () => { await logout(); navigate("/"); }}
                className="font-mono text-xs uppercase tracking-[0.2em] border border-white/20 hover:border-white/50 px-3 py-2 flex items-center gap-2"
              >
                <LogOut className="w-3.5 h-3.5" /> Logout
              </button>
            </>
          ) : (
            <Link
              to="/login"
              data-testid={NAV.loginBtn}
              className="font-mono text-xs uppercase tracking-[0.2em] bg-[#FF3366] text-white hover:bg-[#FF3366]/90 px-4 py-2"
            >
              Sign in
            </Link>
          )}
        </div>
      </div>
    </header>
  );
}
